<cbc-container [isLoading]="isLoading" 
[showContainer]="!isLoading && router.url === '/my-account'" 
title="Minha Conta"
description="Gerencie suas informações, perfis e configurações">
</cbc-container>

@if(!isLoading && router.url === '/my-account') {
<div class="container">

<div class="grid gap-lg" style="grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));">
    <div class="card card-active-link" routerLink="user">
      <div class="flex">
        <div class="card-icon pr-lg ">
          <img src="assets/icons/icon_cadastro.svg" alt="Ícone de cadastro" width="50px" height="50px" />
        </div>
        <div class="text-left">
          <div class="title-secondary">Cadastro</div>
          <div class="title-secondary-description ">Verifique e altere seus dados pessoais e contatos.</div>
        </div>
      </div>
    </div>

    <div class="card card-active-link" routerLink="profiles">
      <div class="flex">
        <div class="card-icon pr-lg ">
          <img src="assets/icons/icon_perfil.svg" alt="Ícone de perfil" width="50px" height="50px" />
        </div>
        <div class="text-left">
          <div class="title-secondary">Meus Perfis</div>
          <div class="title-secondary-description ">Adicione novos perfis e atualize documentos.</div>
        </div>
      </div>
    </div>

    <div class="card card-active-link" routerLink="plans-payments">
      <div class="flex">
        <div class="card-icon pr-lg ">
          <img src="assets/icons/icon_meusplanos.svg" alt="Ícone de cadastro" width="50px" height="50px" />
        </div>
        <div class="text-left">
          <div class="title-secondary">Meus Planos e pagamentos</div>
          <div class="title-secondary-description ">
            Visualize seus planos de acesso e assinaturas.</div>
        </div>
      </div>
    </div>
<!-- 
    <div class="card card-active-link" routerLink="my-payments">
      <div class="flex">
        <div class="card-icon pr-lg ">
          <img src="assets/icons/icon_seuspgtos.svg" alt="Ícone de cadastro" width="50px" height="50px" />
        </div>
        <div class="text-left">
          <div class="title-secondary">Meus Pagamentos</div>
          <div class="title-secondary-description ">
            Acompanhe seus pagamentos e parcelas.</div>
        </div>
      </div>
    </div> -->

    <div class="card card-active-link" routerLink="notification">
      <div class="flex">
        <div class="card-icon pr-lg ">
          <img src="assets/icons/icon_notif.svg" alt="Ícone de cadastro" width="50px" height="50px" />
        </div>
        <div class="text-left">
          <div class="title-secondary">Notificações</div>
          <div class="title-secondary-description ">
            Fique em dia com o que há de novo. Visualize suas notificações.
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

}
<router-outlet />